import * as Yup from "yup";

import {
  ICitizenshipValidationObject,
  citizenshipValidationObject,
} from "./citizenshipValidation";
import { IPepValidationObject, pepValidationObject } from "./pepValidation";

import { CitizenshipPepFormValues } from "./interfaces";

type IValidationObject = ICitizenshipValidationObject & IPepValidationObject;

export const validationObject = (strict = true): IValidationObject => {
  return {
    ...citizenshipValidationObject(strict),
    ...pepValidationObject(),
  };
};

export const validationSchema = (
  strict = true,
): Yup.ObjectSchema<CitizenshipPepFormValues> => {
  return Yup.object(validationObject(strict)).defined();
};
